import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';

import { DataRepository } from '@core/data/data-repository';
import { SubcontractorsApiActions, SubcontractorsPageActions } from './subcontractors.actions';

/**
 * Bridges subcontractors actions to the data layer. Only the initial load is an
 * effect; save/delete are handled synchronously in the reducer (session-only),
 * so there is no persist effect here.
 */
@Injectable()
export class SubcontractorsEffects {
  private readonly actions$ = inject(Actions);
  private readonly repo = inject(DataRepository);

  readonly load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SubcontractorsPageActions.entered),
      switchMap(() =>
        from(this.repo.listSubcontractors()).pipe(
          map((subcontractors) => SubcontractorsApiActions.loadSuccess({ subcontractors })),
          catchError((err: unknown) => of(SubcontractorsApiActions.loadFailure({ error: toMessage(err) }))),
        ),
      ),
    ),
  );
}

function toMessage(err: unknown): string {
  return err instanceof Error ? err.message : 'Unknown error';
}
